import { UIDeviceGroup, UIInstance } from '@ui/Types/Address';

export enum DiscoveryPhase {
    Cancelled = 'Cancelled',
    Completed = 'Completed',
    Error = 'Error',
    Found = 'Found',
    Idle = 'Idle',
    Prompt = 'Prompt',
    Scanning = 'Scanning',
}

export interface DiscoveredGroup {
    devicespecId: number | null;
    groupId: string;
    raw?: unknown; // original response for debugging if needed
}

export interface DiscoveryContextState {
    autoPromptEligible: boolean;
    discovered: DiscoveredGroup | null;
    error: string | null;
    installationID: string | null;
    instanceId: string | null;
    isNewDevice: boolean;
    phase: DiscoveryPhase;
    progress: number;
    stepSubtitle: string; // legacy
    stepTitle: string; // legacy, will be empty for simplified spinner mode
    submitting: boolean;
}

export type DiscoveryAction =
    | { payload: { autoPromptEligible: boolean; installationID: string | null; isNewDevice: boolean }; type: 'INIT' }
    | { type: 'SHOW_PROMPT' }
    | { payload: { instanceId: string | null }; type: 'START_SCAN' }
    | { payload: { progress: number; stepSubtitle?: string; stepTitle?: string }; type: 'SCAN_PROGRESS' }
    | { payload: { devicespecId: number | null; groupId: string; raw?: unknown }; type: 'SCAN_RESULT' }
    | { payload: { error: string }; type: 'SCAN_ERROR' }
    | { type: 'CANCEL' }
    | { type: 'SUBMIT_START' }
    | { type: 'SUBMIT_SUCCESS' }
    | { type: 'RESET' };

export interface ScanProgressUpdate {
    progress: number; // 0-100
    subtitle?: string;
    title: string;
}

export interface ScanResult {
    devicespecId: number | null;
    groupId: string;
    raw?: unknown;
}

export interface ScanStrategy {
    kind: 'tauri' | 'rtc' | 'hybrid';
    start: (
        signal: AbortSignal,
        opts: { instance?: UIInstance | null; instanceId: string | null },
        onProgress: (p: ScanProgressUpdate) => void,
    ) => Promise<ScanResult>;
}

export interface SubmitDetailsPayload {
    brand?: string;
    description: string;
    location: boolean;
    model?: string;
    name: string;
    visible: boolean;
}

export type FormValues = Record<string, string> | UIDeviceGroup;
